$(document).ready(function () {
  //menu mobile
  $(".burger i").on("click", function () {
    $(".navigation").css("display", "flex");
    $(".contenu").hide();
  });

  //fermeture menu mobile
  $(".uil-times").on("click", function () {
    $(".navigation").hide();
    $(".contenu").show();
  });
});
